import Vue from 'vue'
import VueRouter from 'vue-router'
import Login from '../views/login/login.vue'



Vue.use(VueRouter)

const routes = [{
    path: '/',
    redirect: '/home'
  },
  {
    path: "/login",
    component: resolve => require(['@/views/login/login.vue'], resolve),
    meta: {
      title: '海查查' ,// 标题设置
      auth: false
    }
  },
  {
    path: "/detail",
    component: resolve => require(['@/views/home/detail.vue'], resolve),
    meta: {
      title: '海查查' ,// 标题设置
      auth: true
    }
  },
  {
    path: "/home",
    component: resolve => require(['@/views/home/home.vue'], resolve),
    meta: {
      title: '海查查' ,// 标题设置
      auth: true
    }
  },
  {
    path: "/bindphone",
    component: resolve => require(['@/views/user//bindPhone.vue'], resolve),
    meta: {
      title: '绑定手机号' ,// 标题设置
      auth: true
    }
  }
]

const router = new VueRouter({
  routes
})






const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
        return originalPush.call(this, location).catch(err => err)
    }
//  挂载路由导航守卫
 router.beforeEach((to, from, next) => {
    const tokenStr = window.localStorage.getItem('token')
    if (!to.matched.some(record => record.meta.auth == false) && !tokenStr) {
        next('/login')
    } else {
        next()
    }
    if (to.meta.title) {
        document.title = to.meta.title
    }
})
export default router
